// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon;

module.exports.FcSerialTasks = function FcSerialTasks(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "version": "1",
      "viewBox": "0 0 48 48",
      "enableBackground": "new 0 0 48 48"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fill": "#90CAF9",
        "d": "M33,9H11v4h22c1.1,0,2,0.9,2,2v20H23v4h16V15C39,11.7,36.3,9,33,9z"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "6",
        "y": "6",
        "fill": "#D81B60",
        "width": "10",
        "height": "10"
      }
    }, {
      "tag": "g",
      "attr": {
        "fill": "#2196F3"
      },
      "child": [{
        "tag": "rect",
        "attr": {
          "x": "32",
          "y": "17",
          "width": "10",
          "height": "10"
        }
      }, {
        "tag": "rect",
        "attr": {
          "x": "16",
          "y": "32",
          "width": "10",
          "height": "10"
        }
      }, {
        "tag": "circle",
        "attr": {
          "cx": "26",
          "cy": "11",
          "r": "5"
        }
      }, {
        "tag": "circle",
        "attr": {
          "cx": "37",
          "cy": "37",
          "r": "5"
        }
      }]
    }]
  })(props);
};